/* eslint-disable @typescript-eslint/naming-convention */

const colors = {
  primary: {
    '10': '#001B3D',
    '20': '#003063',
    '30': '#00468C',
    '40': '#175DB1',
    '50': '#3B77CB',
    '60': '#5891E7',
    '70': '#79ACFF',
    '80': '#A9C7FF',
    '90': '#D6E3FF',
    '95': '#ECF0FF',
    '99': '#FDFBFF',
  },
}

export default colors
